import { render, staticRenderFns } from "./giftSet.vue?vue&type=template&id=0a070a46&scoped=true&"
import script from "./giftSet.vue?vue&type=script&lang=js&"
export * from "./giftSet.vue?vue&type=script&lang=js&"
import style0 from "./giftSet.vue?vue&type=style&index=0&id=0a070a46&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a070a46",
  null
  
)

export default component.exports